import init from './init';
import header from './sections/header';

init();
header();



// WEBPACK FOOTER //
// ./source/scripts/main.js